/** A choice this browser keeps for the creator, or null when there is none or storage is refused. */
export function remembered(key: string): string | null {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function remember(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    /* a browser that refuses storage keeps the choice for this page only */
  }
}
